export default {
  brochureCount: state => {
    return state.brochures.filter(brochure => brochure.selected).length;
  },
  brochureSelection: state => {
    return state.brochures.filter(brochure => brochure.selected);
  },
  brochureFormIsValid: (state, getters, rootState, rootGetters) => {
    return (
      rootGetters.formIsValid(['brochureRequest', 'form']) &&
      rootGetters.formIsValid(['brochureRequest', 'form', 'address']) &&
      rootGetters.formIsValid(['brochureRequest', 'form', 'address', 'fields', 'addressLines'])
    );
  },
  formData: (state, getters, rootState, rootGetters) => {
    const userDetails = rootGetters.formDataFlat(['brochureRequest', 'form']);
    const address = rootGetters.formDataFlat(['brochureRequest', 'form', 'address']);
    return {
      ...userDetails,
      address
    };
  },
}